import { FC } from 'react';
import { Box } from '@mui/material';

interface CustomTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const CustomTabPanel: FC<CustomTabPanelProps> = ({
  children,
  index,
  value,
}) => {
  return <>{index === value && <Box>{children}</Box>}</>;
};
